// import { useState } from "react"
import { useRouter } from "next/router"
import { useSelector, useDispatch } from "react-redux"
import { Box, Typography, Container, Button } from "@mui/material"
import Link from "next/link"
import Layout from "@/components/layouts/Layout"
import AutocompleteSearchField from "@/components/doctors/AutocompleteSearchField"
import SelectedCard from "@/components/doctors/SelectedCard"
import { setSelectedDoctor } from "@/store/slice/application"
// import { getDoctor } from "@/services/doctorService"
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline"
import OpenInNewIcon from "@mui/icons-material/OpenInNew"
import { AP_STAGE } from "@/helpers"

const DoctorApplicationClaimPage = () => {
  const router = useRouter()
  const dispatch = useDispatch()
  const { selectedDoctor } = useSelector(state => state.application)

  const handleDoctorSearch = async data => {
    if (data) {
      // fetch doctor data by data.id
      // and dump into setSelectedDoctor
      // remove this when educations, experiences been added into data
      // const doctorDetail = await getDoctor(data.id)
      dispatch(setSelectedDoctor(data))
    }
  }

  const removeSelectedDoctor = () => {
    dispatch(setSelectedDoctor(null))
  }

  return (
    <Layout>
      <Container maxWidth="sm" sx={{ m: "auto" }}>
        <Box
          sx={{
            m: "auto",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: 2,
            my: 5,
          }}
        >
          <Typography
            component="h2"
            sx={{ typography: { xs: "headingH5Heavy", sm: "headingH4Heavy" } }}
          >
            認領PinMed上的醫事人員頁面
          </Typography>
          <Typography component="p" variant="body16PxRegular" align="center" sx={{ mt: 2 }}>
            您的執業院所建立醫療團隊資料時可能已為您建立專屬頁面，在此搜尋您的名字並開始認領。
          </Typography>

          {selectedDoctor ? (
            <>
              {/* Alert Start */}
              {selectedDoctor.approvedAt && (
                <>
                  <Box
                    sx={{
                      mt: 3,
                      width: "100%",
                      backgroundColor: "#FEFBCC",
                      color: "#776700",
                      borderRadius: 1,
                      display: "flex",
                      flexWrap: "wrap",
                      justifyContent: "space-between",
                      px: 2,
                      py: 1.5,
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 1,
                      }}
                    >
                      <CheckCircleOutlineIcon fontSize="small" />
                      <Typography variant="headingMediumMedium">
                        此頁面已被認領，如果有任何疑問請聯絡
                        <Link
                          sx={{ color: "#776700" }}
                          href={"https://lin.ee/vT9R0c5"}
                          target="_blank"
                        >
                          &nbsp;PinMed 客服
                        </Link>
                        。
                      </Typography>
                    </Box>
                  </Box>
                </>
              )}
              {/* Alert End */}

              <SelectedCard doctorData={selectedDoctor} />

              <Box>
                <Typography
                  sx={{
                    color: "SHADES_600",
                    display: "flex",
                  }}
                  variant="headingMediumMedium"
                >
                  想查看完整頁面嗎？
                  <Link
                    sx={{
                      color: "PRIMARY_700",
                      display: "flex",
                      justifyItems: "center",
                      alignItems: "center",
                    }}
                    href={`${
                      AP_STAGE === "staging"
                        ? "https://pinmed-git-feature-searching-30-alleypin.vercel.app"
                        : "https://pinmed.co"
                    }/doctor/${selectedDoctor.basicID}`}
                    target="_blank"
                  >
                    點此前往
                    <OpenInNewIcon
                      sx={{
                        pl: 0.5,
                      }}
                      fontSize="small"
                    />
                  </Link>
                </Typography>
              </Box>

              <Box sx={{ display: "flex", gap: 1, alignSelf: "flex-end" }}>
                {selectedDoctor.approvedAt ? (
                  <>
                    <Button
                      sx={{
                        backgroundColor: "PRIMARY_600",
                      }}
                      variant="contained"
                      onClick={() => removeSelectedDoctor()}
                    >
                      返回
                    </Button>
                  </>
                ) : (
                  <>
                    <Button variant="outlined" onClick={() => removeSelectedDoctor()}>
                      取消
                    </Button>
                    <Button
                      sx={{
                        backgroundColor: "PRIMARY_600",
                      }}
                      variant="contained"
                      onClick={() => router.push("/doctor/application/create")}
                    >
                      開始認領
                    </Button>
                  </>
                )}
              </Box>
            </>
          ) : (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1,
                p: 3,
                width: "100%",
                backgroundColor: "SHADES_100",
                borderRadius: 2,
                my: 4,
              }}
            >
              <Typography variant="body16PxRegular">搜尋醫事人員</Typography>
              <AutocompleteSearchField
                id={"search-clinic"}
                name={"search-clinic"}
                initialValue={selectedDoctor}
                getValue={handleDoctorSearch}
              />
            </Box>
          )}

          {!selectedDoctor && (
            <Box sx={{ py: 2 }}>
              找不到您的名字嗎？
              <Link sx={{ color: "PRIMARY_600" }} href={"/doctor/application/create"}>
                點我建立新頁面
              </Link>
            </Box>
          )}
        </Box>
      </Container>
    </Layout>
  )
}

export default DoctorApplicationClaimPage
